import {
  DetailedHTMLProps,
  forwardRef,
  InputHTMLAttributes,
  LegacyRef,
  ReactNode,
} from "react";

import { RadioGroupLayout } from "../radioGroup/RadioGroup";

import styles from "./RadioButton.module.scss";

type RadioButtonProps = DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  freeEntryComponent?: ReactNode;
  label: string;
  layout: RadioGroupLayout;
};

const RadioButton = forwardRef(
  (
    { freeEntryComponent, layout, ...props }: RadioButtonProps,
    ref: LegacyRef<HTMLInputElement> | undefined
  ) => {
    if (layout === "cards") {
      return (
        <div className={styles.card}>
          <input
            ref={ref}
            className={styles.cardRadio}
            type="radio"
            onFocus={(e) => {
              /**
               * iOS Safari doesn't scroll radio inputs into view, so we trigger it manually.
               * Luckily it's only been an issue for half a decade.
               *
               * https://stackoverflow.com/questions/56137175/ios-safari-chrome-wont-scroll-up-to-show-validation-error-message-on-radio-inpu/67215758#67215758
               */
              if (navigator.platform === "iPhone") {
                e.target.scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              }
            }}
            {...props}
          />

          <label className={styles.cardLabel} htmlFor={props.id}>
            {props.label}
          </label>
        </div>
      );
    }

    return (
      <label className={styles.label}>
        <input
          ref={ref}
          className={styles.radio}
          type="radio"
          onFocus={(e) => {
            if (navigator.platform === "iPhone") {
              e.target.scrollIntoView({
                block: "center",
                behavior: "smooth",
              });
            }
          }}
          {...props}
        />

        {freeEntryComponent ? (
          <div className={styles.freeEntryWrapper}>
            {props.label}
            {freeEntryComponent}
          </div>
        ) : (
          <span className={styles.value}>{props.label}</span>
        )}
      </label>
    );
  }
);

export default RadioButton;
